export interface IModel {
    id: string;
    name: string;
    description: string;
    category: "Anthropic";
    maxTokens: number;
}

export const MODELS: IModel[] = [
    {
        id: "us.anthropic.claude-opus-5-5",
        name: "Claude Opus 5.5",
        description: "Deep Thinking",
        category: "Anthropic",
        maxTokens: 128_000,
    },
    {
        id: "us.anthropic.claude-opus-4-8",
        name: "Claude Opus 4.8",
        description: "Deep Thinking",
        category: "Anthropic",
        maxTokens: 128_000,
    },
    // Bedrock has no us. inference profile for Sonnet 5.5, only global.
    {
        id: "global.anthropic.claude-sonnet-5-5",
        name: "Claude Sonnet 5.5",
        description: "General Usage",
        category: "Anthropic",
        maxTokens: 128_000,
    },
    {
        id: "us.anthropic.claude-haiku-4-5-20251001-v1:0",
        name: "Claude Haiku 4.5",
        description: "Fast Response",
        category: "Anthropic",
        maxTokens: 64_000,
    },
];

export const DEFAULT_MODEL_ID = "global.anthropic.claude-sonnet-5-5";

export const getModelById = (id: string): IModel | undefined => {
    return MODELS.find((model) => model.id === id);
};

export const getModelName = (id: string): string => {
    const model = getModelById(id);
    return model?.name || id;
};

export const DEFAULT_MAX_TOKENS = 64_000;

export const getMaxTokens = (modelId: string): number => {
    return getModelById(modelId)?.maxTokens ?? DEFAULT_MAX_TOKENS;
};
